import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This example demonstrates the advantage of binaural hearing for localization of sound. Please focus on the movement of the sound source while listening to the recordings.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "panner",
            options: {
              audio: [
                { text: "Mono", url: `${config.ASSETS_URL}/02/11/principle/rotating-guitar-mono.wav` },
                { text: "Binaural", url: `${config.ASSETS_URL}/02/11/principle/rotating-guitar-binaural.wav` },
              ],
            },
          },
        },
      },
    },
  },
};

export default principle;
